/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateScanTriggerResponse {
    getFixupPrototypeFunction() { return TemplateScanTriggerResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateScanTriggerResponse>): TemplateScanTriggerResponse {
        let obj = Object.assign(new TemplateScanTriggerResponse(), model);
        TemplateScanTriggerResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateScanTriggerResponse>): TemplateScanTriggerResponse {
        if (!model) return null;
        return TemplateScanTriggerResponse.newInstance(<TemplateScanTriggerResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateScanTriggerResponse) {
        if (!obj) return;

        models.TemplateScanTriggerResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateScanTriggerResponse): boolean {
        Object.setPrototypeOf(obj, TemplateScanTriggerResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID to poll for results. Absent if scanning was skipped - no checks exist for this template's engine type
     */
    scan_id: string;

}
